import type { FaireProductEntity } from "../../entity_types/product";

export const p_y4nj9hy2yr: FaireProductEntity = {
  token: "p_y4nj9hy2yr",
  type: "product",
  name: "Vintage Style RING",
  brandToken: "b_azjmuj2qt2",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/fa9db1b77604cd92aba87a002b504c012a7b7bb3b2e3d6aaf776cfefa0d510c6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08cad597701fc3490f9ced025a2a72213bb9a51ba1d75b2f5c3bd7e681d3a25d.jpeg",
    "https://cdn.faire.com/fastly/a78f678fd4fd83c92b74a8878f8a3e8ace22db2b8a47938a8f52dc7a76426a8b.jpeg",
    "https://cdn.faire.com/fastly/c21d10f3a434324de37c6443384318b1dc63a7fdada47d99bebf91486aa5e6c9.jpeg",
    "https://cdn.faire.com/fastly/9d61a0f678d65c0df3efbeb5e26f9b94ee12e963cdf863775390957d16fca3fd.jpeg",
    "https://cdn.faire.com/fastly/6bb549d6965c774a4170076c9b87d5f802618e15ad2d7931ed909d27241e6169.jpeg",
    "https://cdn.faire.com/fastly/6e3a0bb97f0ea8246c87933c81e824791fe593cff1a725cd69f42f1b1c17e510.jpeg",
    "https://cdn.faire.com/fastly/240a3654ca6d0a8c36bc5bffd0635396751018dd336c7904f04f90922a6d70dd.jpeg",
    "https://cdn.faire.com/fastly/4ea72b3cc8db225e268a510e60321677b34271a931931e8b18f575b3078afdd2.jpeg",
    "https://cdn.faire.com/fastly/c745d0ddbf10bd711c46553b950d3445ec785c49f1ac34bb49b98a8174bdbbad.jpeg",
    "https://cdn.faire.com/fastly/25e0b0fe5d8cf2475d57a2874a4a3d572d96518e763a922ca951c9257627fb1e.jpeg",
    "https://cdn.faire.com/fastly/1461a4bd235c861f33a9f4481ea48357f186093b39056ac3c32f3c5b8b1d7658.jpeg"
  ],
  priceDollars: 14,
  description: "Treat yourself to the sparkly, bohemian vibes of our Vintage Style RING. Crafted from stainless steel and adorned with big and bold colorful zirconia, in your choice of green, white, or pink, this luxe design will add some wow factor to your look! Get ready to turn heads wherever you go!\n\n * Made of premium Stainless Steel, so won't discolor! \n * This ring comes in different sizes ",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:45.801Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
